import React from 'react';
import Rating from 'react-rating';
import { useIsRequiredElement } from '../../../hook/useIsRequiredElement';
import ElementErrorMessage from './components/element-error-message';

export const RatingElement = function FromElement({ element, handlerChange, formHasOnlyOneSubmitter, error }) {
  const isRequiredElement = useIsRequiredElement(element, formHasOnlyOneSubmitter);
  return (
    <>
      <label
        className="form-label w-full"
        style={{ zIndex: 5000 + (element.options.zIndex || 10), width: 'fit-content', position: 'relative' }}
      >
        {element.options.name} <span className="required">{isRequiredElement ? '*' : ''}</span>
      </label>
      <Rating
        className={`form-control-star form-control-star-${element.options.size} ${element.options.readOnly ? 'readonly' : ''}`}
        fractions={2}
        emptySymbol="icon-star-empty"
        fullSymbol="icon-star-full"
        readOnly={element.options.readOnly}
        initialRating={element.options.valueInput}
        onChange={(e) => handlerChange(element, e)}
      />
      <ElementErrorMessage message={error} />
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </>
  );
};
